"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiAlertDialogWhenTriggeredPicker = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var util_1 = require("@gooddata/util");
var kpiAlertTypeItems = [
    { title: "kpiAlertDialog.threshold.above", id: "aboveThreshold" },
    { title: "kpiAlertDialog.threshold.below", id: "underThreshold" },
];
exports.KpiAlertDialogWhenTriggeredPicker = function (_a) {
    var intl = _a.intl, onWhenTriggeredChange = _a.onWhenTriggeredChange, whenTriggered = _a.whenTriggered;
    var alertTypeItems = react_1.useMemo(function () {
        return kpiAlertTypeItems.map(function (item) { return (tslib_1.__assign(tslib_1.__assign({}, item), { title: intl.formatMessage({ id: item.title }) })); });
    }, [intl]);
    var selectedItem = alertTypeItems.find(function (item) { return item.id === whenTriggered; });
    return (react_1.default.createElement(sdk_ui_kit_1.Dropdown, { className: "alert-select s-alert_select", renderButton: function (_a) {
            var toggleDropdown = _a.toggleDropdown;
            return (react_1.default.createElement(sdk_ui_kit_1.DropdownButton, { className: "dropdown-button", value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title, onClick: toggleDropdown }));
        }, renderBody: function (_a) {
            var closeDropdown = _a.closeDropdown;
            return (react_1.default.createElement(sdk_ui_kit_1.DropdownList, { className: "s-alert-list", width: 256, items: alertTypeItems, itemsCount: alertTypeItems.length, renderItem: function (_a) {
                    var item = _a.item;
                    return (react_1.default.createElement("div", { className: classnames_1.default("gd-list-item", "gd-list-item-shortened", "s-" + util_1.stringUtils.simplifyText(item.title)), onClick: function (e) {
                            e.preventDefault();
                            onWhenTriggeredChange(item.id);
                            closeDropdown();
                        } },
                        react_1.default.createElement(sdk_ui_kit_1.ShortenedText, null, item.title)));
                } }));
        } }));
};
//# sourceMappingURL=KpiAlertDialogWhenTriggeredPicker.js.map